import { VwoService } from './../../../../shared/services/vwo/vwo.service';
import { Component, HostListener, Input, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { FundraiserService } from '../../../../shared/services/fundraiser/fundraiser.service';
import { UtilService, VariablesService, TickrService } from '../../../../shared/services';
import { AcknowledgeFormComponent } from '../../../acknowledge-form/components/acknowledge-form/acknowledge-form.component';
import { ICurrency } from '../../../../shared/models';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-view-supporters',
  templateUrl: './view-supporters.component.html',
  styleUrls: ['./view-supporters.component.scss']
})
export class ViewSupportersComponent implements OnInit, OnDestroy {

  @Input() public customTag;
  @Input() public fundraiser;
  @Input() public settings;
  @Input() public isFundraiserEnded;
  @Input() public origin;
  @Input() public donationCard?;
  @Input() public isDonated?;
  @Input() public tickrIsShown?;
  @Input() public theme = 'v1';
  tickrSubscription: Subscription[] = [];
  donorError;
  isMobile: any;
  supportersOnScroll = [];
  donorsOrderBy = 'donated_amount';
  page = {
    sortby: 'desc',
    limit: 10,
    page: 1,
    orderby: ''
  };
  payment_option = {
    wallet: 'wallet',
    paytm: 'paytm',
    upi: 'upi',
    bank: 'bank'
  };
  isLoader;
  @ViewChild('viewSupporters', { static: true }) public viewSupporters;
  supporterImg;
  isListContinue = true;
  currencyInfo: ICurrency;
  currencySubscription: Subscription;
  fakeTickrSupportersCount: any;
  willTickrShow = false;
  dialogRef;

  constructor(
    public fundraiserService: FundraiserService,
    public utilService: UtilService,
    public dialog: MatDialog,
    public variablesService: VariablesService,
    public tickrService: TickrService,
    public vwoService: VwoService
  ) { }

  ngOnInit() {
    this.isMobile = this.utilService.isMobile();
    this.fakeTickrSupportersCount = this.tickrService.reduceDonorsBy;
    this.getSupportersImages();
    if (this.origin === 'stories') {
      this.page.orderby = 'id';
    } else {
      this.page.orderby = 'donated_amount';
    }
    this.getCurrency();
    if (!this.tickrService.stopTickr) {
      this.onTickrClick();
    }
  }
  /**Get Supporters images */
  getSupportersImages() {
    this.supporterImg = `/assets/images/random_supporters/${Math.floor(Math.random() * 10) + 1}.png`;
  }
  getRandomInt(min, max) {
    return Math.floor(Math.random() * (max - min) + min);
  }
  navigateToSignIn() {
    const domain_details = this.utilService.domain_details;
    const url = `${domain_details.domain_url}/login/login.php?redirect_uri=${encodeURIComponent(domain_details.full_url)}`;
    this.utilService.nativeNavigation(url);
  }
  /**Open contact dailog */
  openDialog(template): void {
    this.dialogRef = this.dialog.open(template, {
      width: this.utilService.isMobile() ? '100vw' : '448px',
      maxWidth: this.utilService.isMobile() ? '100vw' : '80vw',
      height: this.utilService.isMobile() ? '90vh' : '65vh',
      panelClass: 'view-suppoters-dialog'
    });
    this.getSupporters(this.customTag, this.page);
  }
  @HostListener('scroll', ['$event'])
  onScroll(event: any, name) {
    if (event.target.offsetHeight + event.target.scrollTop >= event.target.scrollHeight - 5) {
      this.page.page++;
      this.getSupportersOnScroll(this.customTag, this.page);
    }
  }
  /**get sort order by */
  getSortOrder(ordrby) {
    return this.donorsOrderBy === ordrby ? 'primary' : '';
  }
  sortDonors(ordrby) {
    this.donorsOrderBy = ordrby;
    this.page.orderby = ordrby;
    this.page.page = 1;
    this.isListContinue = true;
    this.getSupporters(this.customTag, this.page);
  }
  /**Supporters On scroll */
  getSupportersOnScroll(customTag, page) {
    if (this.isListContinue) {
      this.isLoader = true;
      // tslint:disable-next-line:max-line-length
      const qParam = `?with=activation;comments&limit=${page.limit}&page=${page.page}&orderBy=${page.orderby}&sortedBy=${page.sortby}`;
      this.fundraiserService.getDonors(customTag, qParam).subscribe((res: any) => {
        for (const item of res.data.data) {
          this.supportersOnScroll.push(item);
        }
        this.isLoader = false;
        this.isListContinue = this.checkForEmptyArray(res.data.data);
      }, (error) => {
        this.isListContinue = false;
        this.isLoader = false;
        this.donorError = this.variablesService.social ? error : null;
      });
    }
  }
  /**Supporters On scroll */
  getSupporters(customTag, page) {
    if (this.isListContinue) {
      // tslint:disable-next-line:max-line-length
      const qParam = `?with=activation;comments&limit=${page.limit}&page=${page.page}&orderBy=${page.orderby}&sortedBy=${page.sortby}`;
      this.fundraiserService.getDonors(customTag, qParam).subscribe((res: any) => {
        this.supportersOnScroll = res.data.data;
        this.isListContinue = this.checkForEmptyArray(res.data.data);
      }, (error) => {
        this.isListContinue = false;
        this.donorError = this.variablesService.social ? error : null;
      });
    }
  }

  checkForEmptyArray(data) {
    return data && data.length ? true : false;
  }

  ackPopup() {
    this.dialog.open(AcknowledgeFormComponent, {
      data: { mode: this.payment_option.paytm },
      width: '100vw',
      height: '100vh',
      maxWidth: '600px',
      maxHeight: this.isMobile ? '100vh' : '550px',
    });
  }

  /**
   * Get the currency of the from
   * currency observable
  */
  getCurrency() {
    this.currencySubscription = this.utilService.currency.subscribe({
      next: (res) => {
        if (res) {
          this.currencyInfo = this.utilService.getCurrencyIcon(res);
        }
      }
    });
  }

  private preTickrProcessing() {
    this.supportersOnScroll.splice(0, this.fakeTickrSupportersCount);
    for (let i = 0; i < this.tickrService.tickrData.length; i++) {
      this.supportersOnScroll.unshift(this.tickrService.tickrData[i]);
    }
  }

  onTickrClick() {
    this.tickrSubscription.push(
      this.tickrService.willTickrShowObs.subscribe((data) => {
        setTimeout(() => {
          this.willTickrShow = data;
          if (this.willTickrShow) {
            this.fundraiser.raised.backers -= this.fakeTickrSupportersCount;
          }
        }, 0);
      })
    );
    this.tickrSubscription.push(
      this.tickrService.tickrClickObs.subscribe((data) => {
        if (data) {
          this.dialog.closeAll();
          this.openDialog(this.viewSupporters);
        }
      })
    );
    this.tickrSubscription.push(
      this.tickrService.tickrIsShown.subscribe((data) => {
        if (data) {
          this.fundraiser.raised.beforeTickr = this.fundraiser.raised.raised;
          this.fundraiser.raised.raised += data.donated_amount_current;
          ++this.fundraiser.raised.backers;
          /** Animate amount raised by fundraiser ends*/
          // if (!this.dialogRef) {
          //   return;
          // } else {
          //   this.supportersOnScroll.unshift(data);
          // }
        }
      })
    );
  }

  ngOnDestroy() {
    this.tickrSubscription.forEach(subscription => subscription.unsubscribe());
  }

}
